import React, { useState } from "react";
import AttachmentModal from "../../AttachmentModal/index";
import "./style.scss";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { normalizeService, calculateChargeableWeight } from "../../../utils";

const ServiceNonDox = ({ allAppData, creditCharges }) => {
  // const childAwbNo = allAppData?.childShipmentDetails?.map((data) => {
  //   return `${data?.childAwbNumber}${data?.ewayBillNumber ? `(${data?.ewayBillNumber})` : ""}`;
  // });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getChargeableWeight = calculateChargeableWeight(
    allAppData?.shipmentDetails,
    allAppData?.childShipmentDetails
  );

  const parentWeight = allAppData?.shipmentDetails?.weight || 0;

  const parentVolumetricWeight = allAppData?.shipmentDetails?.volumetricWeight|| 0;

  const childWeight =
    allAppData?.childShipmentDetails?.reduce(
      (sum, child) => sum + child?.weight || 0,
      0
    ) || 0;
  const childVolumetricWeight =
    allAppData?.childShipmentDetails?.reduce(
      (sum, child) => sum + child?.volumetricWeight || 0,
      0
    ) || 0;


  const totalWeight = parentWeight + childWeight || 0;
  const parentVolNChildVol = parentVolumetricWeight + childVolumetricWeight || 0;

  return (
    <div className="service-summary">
      <AttachmentModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        dataFile={allAppData?.files}
      />
      <table>
        {/* left */}

        <tr>
          <td className="table-data top-left">
            <div className="heading">Type:</div>{" "}
            <div className="item">
              {allAppData?.shipmentDetails?.type
                ? allAppData?.shipmentDetails?.type
                : null}
            </div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Service :</div>{" "}
            <div className="item">
              {normalizeService(allAppData?.serviceDetails?.service)}
            </div>{" "}
          </td>

          <td className="table-data">
            <div className="heading">Travel by :</div>{" "}
            <div className="item">{allAppData?.serviceDetails?.travelBy}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Content :</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.content}</div>
          </td>
          <td className="table-data">
            <div className="heading">Remarks :</div>{" "}
            <div className="item">
              {allAppData?.shipmentDetails?.description || "N/A"}
            </div>
          </td>
          {/* <td className="table-data ">
            <div className="heading">Description :</div>{" "}
            <div className="item">
              {allAppData?.shipmentDetails?.description || ""}
            </div>{" "}
          </td> */}
          <td className="table-data ">
            <div className="heading">Value:</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.value}</div>{" "}
          </td>

          <td className="table-data">
            <div className="heading">Uploaded files :</div>{" "}
            <div className="item">
              {allAppData?.files?.length > 0 ? (
                <a onClick={() => setIsModalOpen(true)}>
                  {allAppData?.files?.length} Attachment(s)
                </a>
              ) : (
                `${allAppData?.files?.length} Attachment(s)`
              )}
            </div>
            {/* <a className="item">{allAppData?.files?.length} attachment(s)</a> */}
          </td>
          <td className="table-data no-packet">
            <div className="content">
              <div className="heading">
                No. of child
                <br /> packets :
              </div>
              <div className="item">
                {allAppData?.childShipmentDetails?.length || 0}
              </div>
            </div>
            {/* <div className="itemone">{childAwbNo?.join(", ") || ""}</div>{" "} */}
          </td>
          <td className="table-data">
            <div className="heading">E-Way bill no :</div>{" "}
            <div className="item">
              {allAppData?.ewaybills
                ?.map((val) => val?.ewayBillNumber)
                .join(", ") || "N/A"}
            </div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Sender’s GST number :</div>{" "}
            <div className="item">
              {allAppData?.addressDetails?.senderGst
                ? allAppData?.addressDetails?.senderGst
                : "N/A"}
            </div>{" "}
          </td>
        </tr>

        {/* //right */}

        <tr>
          <td className="table-data top-right">
            <div className="heading">Weight (Kg) :</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.weight?.toFixed(2) || 0}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Length (Cm) :</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.length}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Width (Cm) :</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.width}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Height (Cm) :</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.height}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Vol weight (Kg) :</div>{" "}
            <div className="item">
              {allAppData?.shipmentDetails?.volumetricWeight?.toFixed(2) || 0}
            </div>{" "}
          </td>
          <td className="table-data top-right">
            <div className="heading">Total Weight(Kg): </div>{" "}
            <div className="item">{totalWeight?.toFixed(2) || 0}</div>{" "}
          </td>
          <td className="table-data top-right">
            <div className="heading">Total Vol weight(Kg): </div>{" "}
            <div className="item">{parentVolNChildVol?.toFixed(2) || 0}</div>{" "}
          </td>
          <td className="table-data top-right">
            <div className="heading">Total chargeable weight(Kg): </div>{" "}
            <div className="item">{getChargeableWeight || 0}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">
              Charges
              <span style={{ marginLeft: 5 }}>
                <Tooltip
                  placement="right"
                  title="If charges is 0 then wait for 30 minutes for charges to be updated"
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </span>
              {"   "} :
            </div>{" "}
            <div className="item">{creditCharges || 0}</div>
          </td>

        
          {/* <td className="table-data child-packet">
            <div className="heading">Child packet tracking no :</div>{" "}
            <div className="item">{childAwbNo?.join(", ") || ""}</div>{" "}
          </td> */}
        </tr>
      </table>
    </div>
  );
};

export default ServiceNonDox;
